var Legend   = require("./Legend"),
    $        = require("jquery");

var ThematicLegend = Legend.extend({

    initialize: function (options) {
        var that = this;

        /*var tt = {
         'type'      : 3,
         'name'      : 'легенда пузырьков',
         'showValues': true,
         'minValue'  : 100,
         'maxValue'  : 500,
         'fill'      : '#ffffff',
         'isIcon'    : false,
         'separators': [{
         'value': '100500',
         'size' : 50,
         'idx'  : '1'
         }]
         };*/

        options || (options = {});

        options = $.extend(true, {
            "name"      : "",
            "showValues" : null,
            "classificators": []
        }, options);

        ThematicLegend.__super__.initialize.apply(that, arguments);

        that._container.addClass('omjs-thematic-legend');

        that.setClassificators(options.classificators)
    },

    _getTemplate: function(){
        return require("./thematic.ejs");
    },

    setClassificators: function(classificators){
        var that = this,
            delta,
            i=1;

        classificators = $.isArray(classificators) ? classificators : [];
        that.options.classificators = [];


        if(classificators.length < 7){
            that.options.classificators = classificators;
        }else{
            delta = classificators.length / 6;

            that.options.classificators[0] = classificators[0];

            while(i < 6){
                that.options.classificators.push(classificators[parseInt(i*delta)])
                i++;
            }

            that.options.classificators.push(classificators[classificators.length-1]);
        }

        that._buildLegend();
    },

    setMinValue: function (value) {
        var that = this;

        if ($.type(value) !== "number") {
            return that;
        }

        that.options.minValue = value;
        that._buildLegend();

        return that;
    },

    setMaxValue: function (value) {
        var that = this;

        if ($.type(value) !== "number") {
            return that;
        }

        that.options.maxValue = value;
        that._buildLegend();

        return that;
    }
});

module.exports = ThematicLegend;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/Legend/ThematicLegend.js
// module id = 215
// module chunks = 0